import type { StatusItem } from "../analytics";

/** A row of checks, each with an icon and words (never colour alone). */
export function StatusStrip({ items, label }: { items: readonly StatusItem[]; label: string }) {
  return (
    <ul className="status-strip" aria-label={label}>
      {items.map((item) => (
        <li key={item.label} className={`status status-${item.state}`}>
          <span className="status-icon" aria-hidden="true">
            {item.state === "ok" ? "✓" : item.state === "warning" ? "!" : "✕"}
          </span>
          <span className="status-label">{item.label}</span> {item.text}
        </li>
      ))}
    </ul>
  );
}
